import { useLocale } from '@app/core/hooks/useLocale';
import { OpmFirstLastWaterfallDictionaryDto } from '@app/shared/models/contracts/opm-calculation-results-dto';
import styles from '@app/modules/projects/outputs/opm-summary-waterfall/opm-summary-waterfall-erf.module.scss';
import TransactionSummaryRow from '../row-components/TransactionSummaryRow';
import { SubSectionHeader } from '../row-components/SubSectionHeader';

interface InstrumentTotalInterimCashFlowsProps {
  titleColSpan: number;
  opmWaterfall: OpmFirstLastWaterfallDictionaryDto;
  selectedYear: string;
  selectedInstrument: string;
  waterfallIterations: number;
}

const InstrumentTotalInterimCashFlows: React.FC<InstrumentTotalInterimCashFlowsProps> = ({
  titleColSpan,
  opmWaterfall,
  selectedYear,
  selectedInstrument,
  waterfallIterations,
}: InstrumentTotalInterimCashFlowsProps) => {
  const { l } = useLocale();

  return (
    <>
      <SubSectionHeader
        title={l('_TotalInterimCashFlows')}
        className={styles['sub-section-header']}
        titleColSpan={titleColSpan}
      />
      <TransactionSummaryRow
        label="_PostDiscountPV"
        valueKey="interimCashflowsDiscountedFairValue"
        opmWaterfall={opmWaterfall}
        selectedInstrument={selectedInstrument}
        selectedYear={selectedYear}
        waterfallIterations={waterfallIterations}
        isBold
      />
      <TransactionSummaryRow
        label="_CumulativePVOfInterimCashFlows"
        valueKey="interimCashflowsCumulativeDiscountedFairValue"
        opmWaterfall={opmWaterfall}
        selectedInstrument={selectedInstrument}
        selectedYear={selectedYear}
        waterfallIterations={waterfallIterations}
        isBold
      />
    </>
  );
};

export default InstrumentTotalInterimCashFlows;
